import api from "api";
import { useQuery } from "react-query";
import { Country } from "utils/market";
import { queryKeys } from "utils/misc";

export enum Category {
  name = "name",
  id = "id",
  hcp = "hcp",
}

export interface Vars {
  country: Country;
  category: Category;
  search: string;
  pageLimit?: number;
  pageBefore?: unknown;
  pageAfter?: unknown;
}

const useListTherapists = (params: Vars) => {
  const { country, category, search, pageLimit, pageBefore, pageAfter } = params;
  const key = queryKeys.therapistSearch(params);

  return useQuery(
    key,
    async () => {
      const query: any = {
        [category]: search,
        country: country,
      };

      if (pageLimit) {
        query["page[limit]"] = pageLimit;
      }
      if (pageBefore) {
        query["page[before]"] = pageBefore;
      }
      if (pageAfter) {
        query["page[after]"] = pageAfter;
      }

      return api.parse("GET /therapists", { query });
    },
    { enabled: !!search }
  );
};

export default useListTherapists;
